// extracted by mini-css-extract-plugin
module.exports = {"bonusQueueContainer":"styles_bonusQueueContainer__d9d1T","typeBonus":"styles_typeBonus__mOzZa","bonusesQueue":"styles_bonusesQueue__i0pvb"};